export default __webpack_public_path__ + "ceb7e0536542c52be7b33eda6d2d33a1.svg";